import React from "react";
import Common_Banner from "../Common_Components/Common_Heading/Common_Banner/Common_Banner";
import Why_Apply_With_Us from "./why_apply_with_us/Why_Apply_With_Us";

const Apply_Now = () => {
  return (
    <>
      <Common_Banner
        image="/assets/images/home/hero_city_buildings.jpg"
        title="Apply Now"
        subtitle="Join our database of professionals and start your international career journey"
      />
      <Why_Apply_With_Us />
    </>
  );
};

export default Apply_Now;
